export const Valsad = {
    title: "Valsad",
    title1: "(Coastal and Green)",

    attractions: [
        {
            name: "Tithal Beach",
            description: "Tithal Beach is one of the most popular beaches in Valsad. Known for its golden sands and tranquil atmosphere, it is a perfect getaway for those looking to relax by the sea. The beach is also famous for its sunset views and the Tithal Temple located nearby.",
            location: "Tithal Beach, Valsad, Gujarat",
            timings: "24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Relax by the beach",
                "Photography of the sunset",
                "Take a walk along the shore"
            ],
            mapLink: "https://maps.app.goo.gl/Vf97BQQy99gqUwFi9",
        },
        {
            name: "Shree Swaminarayan Temple",
            description: "The Shree Swaminarayan Temple in Valsad is a beautiful temple dedicated to Lord Swaminarayan. The temple is known for its stunning architecture and peaceful atmosphere, attracting both devotees and tourists.",
            location: "Shree Swaminarayan Temple, Valsad, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the daily prayers and rituals",
                "Explore the temple’s intricate carvings",
                "Learn about the Swaminarayan tradition"
            ],
            mapLink: "https://maps.app.goo.gl/BXJ8VGZTk2eD25DJ9",
        },
        {
            name: "Wilson Hills",
            description: "Wilson Hills is a hill station located near Valsad. Known for its cool climate, lush greenery, and beautiful views, it is a popular spot for nature lovers and those looking for a peaceful retreat from the city.",
            location: "Wilson Hills, Near Valsad, Gujarat",
            timings: "24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Monsoon or Winter",
            activities: [
                "Explore the scenic viewpoints",
                "Photography of the lush greenery",
                "Enjoy a picnic amidst nature"
            ],
            mapLink: "https://maps.app.goo.gl/8ytKa7h5j5VhT4zp7",
        },
        {
            name: "Sai Baba Temple",
            description: "Sai Baba Temple in Valsad is a peaceful place of worship dedicated to the revered saint Sai Baba. The temple is known for its serene ambiance, making it an ideal spot for meditation and spiritual reflection.",
            location: "Sai Baba Temple, Valsad, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the prayers and rituals",
                "Engage in meditation and reflection",
                "Explore the peaceful surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/7P8V8b5Ro9WZChtn8",
        },
        {
            name: "Jampore Beach",
            description: "Jampore Beach is another beautiful beach in Valsad. Known for its calm waters and less crowded environment, it is a great place for swimming, sunbathing, and relaxing. The beach also has many water sports activities for adventure enthusiasts.",
            location: "Jampore Beach, Valsad, Gujarat",
            timings: "24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Swim in the calm waters",
                "Engage in water sports",
                "Photography of the beach and surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/hd4HScszFyPhtmoVA",
        },
        {
            name: "Dharampur",
            description: "Dharampur is a small town near Valsad known for its rich culture and beautiful landscapes. The town is surrounded by dense forests and rolling hills, making it a great spot for nature walks and relaxation.",
            location: "Dharampur, Near Valsad, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the nature trails",
                "Photography of the scenic surroundings",
                "Visit the local markets"
            ],
            mapLink: "https://maps.app.goo.gl/Ff9v6mbh3tx51LgM6",
        },
        {
            name: "Vankal Waterfall",
            description: "Vankal Waterfall is a hidden gem near Valsad. The waterfall is surrounded by lush greenery, making it a perfect spot for a nature escape. It is an ideal place for a short trek and offers great opportunities for photography.",
            location: "Vankal Waterfall, Near Valsad, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Monsoon or Post-Monsoon",
            activities: [
                "Trek to the waterfall",
                "Photography of the waterfall and lush surroundings",
                "Enjoy the natural beauty"
            ],
            mapLink: "https://maps.app.goo.gl/F3tsdAtg8E1tJDP87",
        },
        {
            name: "Purna Wildlife Sanctuary",
            description: "Purna Wildlife Sanctuary is located near Valsad and is known for its diverse flora and fauna. The sanctuary is home to a variety of species, including tigers, leopards, and a rich birdlife. It is a great spot for wildlife photography and nature walks.",
            location: "Purna Wildlife Sanctuary, Near Valsad, Gujarat",
            timings: "8:00 AM to 5:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "October to March",
            activities: [
                "Wildlife photography",
                "Nature walks and bird watching",
                "Explore the sanctuary's diverse ecosystems"
            ],
            mapLink: "https://maps.app.goo.gl/5eFYhmRHE9PthZzB9",
        },
        {
            name: "Dholar Eco Tourism",
            description: "Dholar Eco Tourism is a beautiful eco-tourism destination near Valsad. The site offers nature lovers the chance to explore dense forests, rivers, and tribal culture. The area is also known for its vibrant flora and fauna.",
            location: "Dholar Eco Tourism, Near Valsad, Gujarat",
            timings: "6:00 AM to 6:00 PM",
            ticket: "Entry Fee",
            bestTimeToVisit: "October to March",
            activities: [
                "Trekking through the forest",
                "Photography of wildlife and landscapes",
                "Learn about local tribal culture"
            ],
            mapLink: "https://maps.app.goo.gl/v8qQHEioGxwppkFe7",
        }
    ]
};
